import {BlockContainer} from './components/BlockContainer'
import {FactCard} from './components/FactCard'
import type {FlowStep} from './components/FlowDiagram'
import {FlowDiagram} from './components/FlowDiagram'

export type AccessPoint = {
  label: string
  detail: string
}

export type TrustBlockProps = {
  heading: string
  dataDestination: string
  readerResponsibility: string
  accessPoints: AccessPoint[]
  flowSteps: FlowStep[]
}

export const TrustBlock = ({
  heading,
  dataDestination,
  readerResponsibility,
  accessPoints,
  flowSteps,
}: TrustBlockProps) => (
  // id must match HandoffBlock's trust_link_anchor default ("trust") — they're separate
  // variations with no shared field to keep this in sync automatically.
  <section
    id="trust"
    data-slice-type="discovery_block"
    data-slice-variation="trustBlock"
    data-nav-dark="true"
    className="grid scroll-mt-16 grid-cols-main bg-green-base bg-discovery-glow bg-fixed px-5 py-12 md:px-10 md:py-16"
  >
    <div className="col-[inner] w-full max-w-[46.25rem] justify-self-center">
      <BlockContainer headline={heading} subhead={dataDestination}>
        <div className="flex flex-col gap-5">
          {readerResponsibility && <p className="m-0 text-15 text-green-mist-dim">{readerResponsibility}</p>}
          {flowSteps.length > 0 && <FlowDiagram steps={flowSteps} />}
          {accessPoints.length > 0 && (
            <div className="flex flex-wrap gap-3">
              {accessPoints.map((accessPoint, accessPointIndex) => (
                <FactCard key={accessPointIndex} icon="shield" label={accessPoint.label} value={accessPoint.detail} />
              ))}
            </div>
          )}
        </div>
      </BlockContainer>
    </div>
  </section>
)
